import { render, staticRenderFns } from "./Adoptions.vue?vue&type=template&id=1ae23382&scoped=true"
import script from "./Adoptions.vue?vue&type=script&lang=js"
export * from "./Adoptions.vue?vue&type=script&lang=js"
import style0 from "./Adoptions.vue?vue&type=style&index=0&id=1ae23382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae23382",
  null
  
)

export default component.exports